import { render } from "./PrenotazioneAutomezzoDetail.vue?vue&type=template&id=5ea90735&scoped=true"
import script from "./PrenotazioneAutomezzoDetail.vue?vue&type=script&lang=js"
export * from "./PrenotazioneAutomezzoDetail.vue?vue&type=script&lang=js"

import "./PrenotazioneAutomezzoDetail.vue?vue&type=style&index=0&id=5ea90735&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ecocomfort/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea90735"]])

export default __exports__